import { moneyKeyPrefix } from './groupMoneyQuestions'
import { DEFAULT_CURRENCY } from './MoneyFormField'
import { formatMoney, getCurrencyCode } from '@percent/utility'

type MoneyAnswer = { key?: string; answer: string }

const isCurrencyKey = (key: string | undefined) => !!key?.endsWith('.currency')

export const createMoneyAnswers = (moneyAnswers: MoneyAnswer[]) => {
  const answerByKey = new Map(moneyAnswers.map(({ key, answer }) => [key, answer]))

  const siblingAnswer = (key: string | undefined, suffix: 'amount' | 'currency') => {
    const prefix = key === undefined ? undefined : moneyKeyPrefix(key)

    return prefix === undefined ? undefined : answerByKey.get(`${prefix}.${suffix}`)
  }

  return {
    isPairedCurrency: (key: string | undefined) => isCurrencyKey(key) && siblingAnswer(key, 'amount') !== undefined,
    format: (key: string | undefined, answer: string) =>
      isCurrencyKey(key)
        ? answer
        : formatMoney({
            amount: Number(answer),
            currency: getCurrencyCode(siblingAnswer(key, 'currency') ?? '') ?? DEFAULT_CURRENCY
          })
  }
}
